const BASE = '/api';

async function request(path, opts = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
    credentials: 'same-origin',
    ...opts,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error || `http_${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return res.json();
}

export const api = {
  getPackage: (token) => request(`/m/${token}`),
  saveFields: (token, fields) => request(`/m/${token}`, {
    method: 'PATCH', body: JSON.stringify({ fields }),
  }),
  addOwner: (token, owner) => request(`/m/${token}/owners`, {
    method: 'POST', body: JSON.stringify(owner),
  }),
  updateOwner: (token, id, owner) => request(`/m/${token}/owners/${id}`, {
    method: 'PATCH', body: JSON.stringify(owner),
  }),
  removeOwner: (token, id) => request(`/m/${token}/owners/${id}`, { method: 'DELETE' }),
  uploadDocs: async (token, category, files) => {
    const fd = new FormData();
    fd.append('category', category);
    for (const f of files) fd.append('files', f, f.name);
    const res = await fetch(`${BASE}/m/${token}/documents`, { method: 'POST', body: fd });
    if (!res.ok) throw new Error('upload_failed');
    return res.json();
  },
  removeDoc: (token, id) => request(`/m/${token}/documents/${id}`, { method: 'DELETE' }),
  sign: (token, body) => request(`/m/${token}/sign`, {
    method: 'POST', body: JSON.stringify(body),
  }),
};
